import {makeAutoObservable, runInAction} from "mobx";
import {
    reviewMeshGeneratedConfig,
    updateMeshConfig,
    openPromotionGate,
    openRollbackGate,
    removeCanary,
    getMeshStatus,
    getMeshHpaInfo
} from '@/api';
import {sanitizeList} from '@/utils';

const createDefaultMeshState = () => ({
    abUrlMatch: 'prefix',
    abUrlPath: '/',
    abHeaders: [
        {
            match: 'exact',
            key: 'header',
            value: 'value',
        },
    ],
    timeout: 60,
    gateways: [],
    hosts: [],

    appId: '',
    serverName: '',

    primaryHpaExists: false,
    primaryHpaName: undefined,
    canaryHpaExists: false,
    canaryHpaName: undefined,

    operationType: undefined,
});

class MeshStore {

    constructor() {
        Object.assign(this, createDefaultMeshState());
        makeAutoObservable(this, {}, {autoBind: true});
    }

    abUrlMatch;
    abUrlPath;
    abHeaders;
    timeout;
    gateways;
    hosts;

    appId;
    serverName;

    primaryHpaExists;
    primaryHpaName;
    canaryHpaExists;
    canaryHpaName;

    operationType;

    async setHpaInfo(appId, serverName) {
        let res;
        try {
            res = await getMeshHpaInfo(appId, serverName);
            if (res?.code === 200) {
                this.primaryHpaExists = res?.data.primaryHpaExists;
                this.primaryHpaName = res?.data.primaryHpaName;
                this.canaryHpaExists = res?.data.canaryHpaExists;
                this.canaryHpaName = res?.data.canaryHpaName;
            }
        } catch (err) {}

        return res;
    }

    setMeshParams(appId, serverName, record, operationType){
        this.appId = appId
        this.serverName = serverName

        if (record) {
            runInAction(() => {
                this.abUrlMatch = record.match;
                this.abUrlPath = record.uri;
                this.abHeaders = record.headers;
                this.timeout = record.timeout;
                this.gateways = record.gateways || [];
                this.hosts = record.hosts || [];
            });
        }

        if (operationType) {
            runInAction(() => {
                this.operationType = operationType;
            });
        }
    }

    clearMeshParams() {
        Object.assign(this, createDefaultMeshState());
    }

    async reviewMeshGeneratedConfig(params) {
        let res;
        try {
            // using current appId and service
            const appId = this.appId;
            const serverName = this.serverName;
            res = await reviewMeshGeneratedConfig({appId, serverName,
                uri: {path: params.uri, match: params.match},
                headers: params.headers,
                timeout: params.timeout,
                gateways: sanitizeList(params.gateways),
                hosts: sanitizeList(params.hosts),
                hpaRef: params.enableHpa ? this.canaryHpaName : null
            });
            if (res && res.code === 200 && res.data) {
                return res.data;
            }
        } catch (err) {}
        return '';
    }

    async updateMeshConfig(params) {
        let res;
        try {
            // using current appId and service
            const appId = this.appId;
            const serverName = this.serverName;
            res = await updateMeshConfig({appId, serverName,
                uri: {path: params.uri, match: params.match},
                headers: params.headers,
                timeout: params.timeout,
                gateways: sanitizeList(params.gateways),
                hosts: sanitizeList(params.hosts),
                hpaRef: params.enableHpa ? this.canaryHpaName : null
            });
        } catch (err) {}
        return res
    }

    async removeCanary(appId, serverName) {
        let res;
        try {
            res = await removeCanary({
                'id': appId,
                'serverName': serverName
            });
        } catch (err) {}
        return res
    }

    async promoteCanary(appId, serverName) {
        return await openPromotionGate(appId, serverName);
    }

    async rollbackCanary(appId, serverName) {
        return await openRollbackGate(appId, serverName);
    }

    async getMeshStatus() {
        try {
            const res = await getMeshStatus(this.appId, this.serverName);
            if (res && res.code === 200 && res.data) {
                return res.data;
            }
        } catch (err) {}
        return null;
    }
}

export default new MeshStore();